<script lang="ts">
    import { SvelteToast, toast } from '$lib/components/base/toast';
    import type { SvelteToastOptions } from '$lib/components/base/toast/stores';
    import { onMount } from 'svelte';

    const toastOptions: SvelteToastOptions = {
        pausable: true
    };

    const defaultToastOptions: SvelteToastOptions = {
        theme: 'info'
    };

    interface ToastAppEvent extends Event {
        detail?: {
            message: string;
            options?: SvelteToastOptions;
        };
    }

    onMount(() => {
        window.addEventListener('toast-app-add', (e: ToastAppEvent) => {
            const { detail } = e;

            if (detail) {
                toast.push(detail.message, detail.options ?? defaultToastOptions);
            }
        });
    });
</script>

<SvelteToast options={toastOptions} />
